<template>
  <router-view/>
  <img src="@/assets/logo.png" alt="vue logo" class="logo">
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.logo {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 60px;
}
</style>
